import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import styles from './ep-pricing-esm-components-price-summary-price-summary.module.scss.js';
import { clsx } from './ep-pricing-esm-external-clsx-dist-clsx.js';
import { FlexBox, Icon, ErrorBoundary, Typography } from '@vp/swan';
import { useLocalization } from './ep-pricing-esm-hooks-useLocalizations.js';
import { PriceSummaryModal } from './ep-pricing-esm-components-price-summary-price-summary-modal.component.js';

const PriceSummaryInternal = forwardRef((props, ref) => {
  const { className, priceContext, ...rest } = props;
  const classNames = clsx(className, styles.priceSummary);
  const { t } = useLocalization(priceContext.locale);
  const [isOpen, setIsOpen] = useState(false);
  return /* @__PURE__ */ jsxs(FlexBox, { gap: "2", alignItems: "center", ref, textColor: "subtle", fontSize: "small", className: classNames, ...rest, children: [
    t("priceSummary"),
    /* @__PURE__ */ jsx(
      Icon,
      {
        role: "button",
        tabIndex: 0,
        iconType: "info",
        size: "16p",
        skin: "subtle",
        alt: t("priceSummaryInfoIcon"),
        onClick: () => setIsOpen(true),
        style: { cursor: "pointer" }
      }
    ),
    /* @__PURE__ */ jsx(PriceSummaryModal, { isModalOpen: isOpen, onClose: () => setIsOpen(false), ...props })
  ] });
});
forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(
    ErrorBoundary,
    {
      fallback: /* @__PURE__ */ jsx(Typography, { as: "span", textColor: "subtle", fontSize: "small", children: props.placeholdertext }),
      children: /* @__PURE__ */ jsx(PriceSummaryInternal, { ...props, ref })
    }
  );
});

export { PriceSummaryInternal };
//# sourceMappingURL=ep-pricing-esm-components-price-summary-price-summary.component.js.map
